var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _DomFormatter_parser, _DomFormatter_config;
export class DomFormatter {
    constructor(config) {
        _DomFormatter_parser.set(this, new DOMParser());
        _DomFormatter_config.set(this, void 0);
        __classPrivateFieldSet(this, _DomFormatter_config, config, "f");
    }
    format(messages) {
        var _a, _b;
        const domString = messages.map(__classPrivateFieldGet(this, _DomFormatter_config, "f").template).join("");
        const document = __classPrivateFieldGet(this, _DomFormatter_parser, "f").parseFromString(domString, __classPrivateFieldGet(this, _DomFormatter_config, "f").mimeType);
        // In case some ne'er-do-well chatters try injecting html
        document.querySelectorAll("script").forEach((element) => element.remove());
        (_b = (_a = __classPrivateFieldGet(this, _DomFormatter_config, "f")).processDocument) === null || _b === void 0 ? void 0 : _b.call(_a, document);
        return new Blob([document.documentElement.innerHTML], {
            type: __classPrivateFieldGet(this, _DomFormatter_config, "f").mimeType,
        });
    }
}
_DomFormatter_parser = new WeakMap(), _DomFormatter_config = new WeakMap();
export function defaultHtmlTemplate({ timestampMs, displayName, text, }) {
    const dateString = new Date(timestampMs).toLocaleString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "short",
    });
    return `<p><time>${dateString}</time><br><b>${displayName}:</b> ${text}</p>`;
}
export function createHtmlFormatter({ template = defaultHtmlTemplate, processDocument: beforeSerialization, }) {
    return new DomFormatter({
        mimeType: "text/html",
        template,
        processDocument: beforeSerialization,
    });
}
